/**
* DevExpress HTML/JS Reporting (viewer\search\_dxSearchEditor.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import registerComponent from 'devextreme/core/component_registrator';
import { KeyboardEnum } from '@devexpress/analytics-core/analytics-internal';
import dxTextBox from 'devextreme/ui/text_box';
import * as $ from 'jquery';
import * as ko from 'knockout';
var editor_prefix = 'dx-searcheditor', EDITOR_CLASS = editor_prefix + '', EDITOR_BUTTON_SELECTOR = '.' + editor_prefix + '-button';
export class dxSearchEditor extends dxTextBox {
    constructor(element, options) {
        super(element, options);
        this.option('onKeyDown', function (e) {
            if (e.event.key === KeyboardEnum.Enter) {
                e.event.stopPropagation();
                e.event.preventDefault();
                e.component['findNext'](e.event.shiftKey);
            }
        });
        this.option('onFocusOut', function (e) {
            e.component['_searchModel'].searchText(e.component.option('text'));
        });
        this._activeStateUnit = EDITOR_BUTTON_SELECTOR;
        this._focusRequestRaised = () => { this.focus(); };
        this._searchModel = options.searchModel;
        this._searchModel.focusRequested.subscribe((val) => this._focusRequestRaised());
    }
    findNext(searchUp) {
        if (this._searchModel.searchText() !== this.option('text')) {
            this._searchModel.searchText(this.option('text'));
        }
        else {
            try {
                if (searchUp) {
                    (!this._searchModel.loading()) && this._searchModel.findUp();
                }
                else {
                    (!this._searchModel.loading()) && this._searchModel.findDown();
                }
            }
            finally {
                return true;
            }
        }
    }
    _init() {
        super['_init'].apply(this);
        var $element = $.fn.constructor(this.element());
        $element.addClass(EDITOR_CLASS);
        this._koContext = ko.contextFor($element.get(0));
    }
    _render() {
        super['_render'].apply(this);
        this._$buttons = [];
        this.on('keyDown', (e) => {
            if (e.event.key == 'ArrowUp')
                this.findNext(true) && e.event.stopPropagation();
            if (e.event.key == 'ArrowDown')
                this.findNext(false) && e.event.stopPropagation();
        });
    }
}
registerComponent('dxSearchEditor', dxSearchEditor);
